import { Navigate, useLocation } from 'react-router-dom';
import { useTenant } from '../../contexts/TenantContext';
import LandingPage from '../marketing/LandingPage';
import MenuPage from './MenuPage';
import EcommerceStorefront from './EcommerceStorefront';
import BookingPage from './BookingPage';
import { t } from '../../i18n'

// Decides what "/" (and /menu, /shop, /book) renders: the marketing landing
// page on the bare apex domain, or one of the store's services. "/" opens
// the store's first service; a store running several links to the others.
export default function StorefrontIndex({ section }) {
  const tenant = useTenant();
  const location = useLocation();

  if (tenant.loading) {
    return <div className="min-h-screen flex items-center justify-center text-slate-400">{t("Loading...")}</div>;
  }
  if (!tenant.found) {
    return section ? <Navigate to="/" replace /> : <LandingPage />;
  }
  const services = tenant.services || [];
  const shown = section && services.includes(section) ? section : services[0];
  if (section && shown !== section) return <Navigate to={`/${location.search}`} replace />;
  if (shown === 'bookings') return <BookingPage storeName={tenant.name} />;
  if (shown === 'store') return <EcommerceStorefront storeName={tenant.name} />;
  return <MenuPage />;
}
